// extracted by mini-css-extract-plugin
export default {"BtnDir":"btn-dir_BtnDir__auEZL"};